import { compose, withProps } from "recompose";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";
import { withMedias, withTranslations } from "theme/modules/Core";
import { fieldForIdInList } from "theme/utils/extractFromListHelper";
export default () =>
  compose(
    withHideOnErrorBoundary,
    withTranslations((props) => {
      let translationArray = [];
      if (!props.sizeGuide.content) {
        return translationArray;
      }

      if (props.sizeGuide.content.title) {
        translationArray.push(props.sizeGuide.content.title);
      }
      if (props.sizeGuide.content.description) {
        translationArray.push(props.sizeGuide.content.description);
      }
      if (props.sizeGuide.content.link_label) {
        translationArray.push(props.sizeGuide.content.link_label);
      }

      return translationArray;
    }),
    withMedias((props) =>
      props.sizeGuide &&
      props.sizeGuide.content &&
      props.sizeGuide.content.media
        ? [props.sizeGuide.content.media]
        : []
    ),
    withProps((props) => {
      const loading = Boolean(
        props.sizeGuide.mediasLoading || props.sizeGuide.translationsLoading
      );

      if (loading) {
        return {
          loading,
        };
      }
      if (!props.sizeGuide.content) {
        return {
          loading,
          title: "",
          description: "",
          link_label: "",
          media: {},
        };
      }

      const extractMedia = fieldForIdInList(props.medias);
      const extractTranslations = fieldForIdInList(props.translations);

      return {
        loading,
        title: props.sizeGuide.content.title
          ? extractTranslations(props.sizeGuide.content.title, "value", "")
          : "",
        description: props.sizeGuide.content.description
          ? extractTranslations(
              props.sizeGuide.content.description,
              "value",
              ""
            )
          : "",
        link_label: props.sizeGuide.content.link_label
          ? extractTranslations(props.sizeGuide.content.link_label, "value", "")
          : "",
        media: {
          link: props.sizeGuide.content.media
            ? extractMedia(props.sizeGuide.content.media, "url", "/")
            : "",
          type: props.sizeGuide.content.media
            ? extractMedia(props.sizeGuide.content.media, "type", "")
            : "",
          srcset: props.sizeGuide.content.media
            ? extractMedia(props.sizeGuide.content.media, "srcset", "/")
            : "",
        },
      };
    })
  );
